import { Client } from "@microsoft/microsoft-graph-client";
import { AuthCodeMSALBrowserAuthenticationProvider } from "@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getAuthenticatedAccount } from "../../utils/accountUtils";

class SharePointService {
  constructor(msalInstance, account) {
    this.msalInstance = msalInstance;
    this.account = account;
    this.client = this.getAuthenticatedClient();
  }

  getAuthenticatedClient() {
    const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(
      this.msalInstance,
      {
        account: this.account,
        scopes: [process.env.REACT_APP_AUTH_SP_SCOPE],
        interactionType: "popup",
      }
    );

    return Client.initWithMiddleware({
      authProvider,
    });
  }

  async uploadFile(file, fileName) {
    try {
      const siteId = process.env.REACT_APP_SP_SITE_ID;
      const driveId = process.env.REACT_APP_ENVIRONMENTAL_DOCUMENT_LIBRARY_DRIVE_ID;

      const uploadResponse = await this.client
        .api(`/sites/${siteId}/drives/${driveId}/root:/${fileName}:/content`)
        .put(file);

      const fileDetails = await this.client
        .api(`/sites/${siteId}/drives/${driveId}/items/${uploadResponse.id}`)
        .select('webUrl')
        .get();

      return {
        ...uploadResponse,
        downloadLink: fileDetails.webUrl
      };
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        const tenantId = process.env.REACT_APP_AUTH_TENENT_ID;
        const accounts = await this.msalInstance.getAllAccounts();
        this.account = await getAuthenticatedAccount(this.msalInstance, accounts, tenantId);
        this.client = this.getAuthenticatedClient();
        return this.uploadFile(file, fileName);
      }
      throw error;
    }
  }

  async deleteFile(fileId, driveId = null) {
    try {
      const siteId = process.env.REACT_APP_SP_SITE_ID;
      // If no driveId is provided, use the Unentered Documents drive ID
      const targetDriveId = driveId || process.env.REACT_APP_UNENTERD_DOCUMENTS_DRIVE_ID;

      await this.client
        .api(`/sites/${siteId}/drives/${targetDriveId}/items/${fileId}`)
        .delete();

      return { success: true };
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        const tenantId = process.env.REACT_APP_AUTH_TENENT_ID;
        const accounts = await this.msalInstance.getAllAccounts();
        this.account = await getAuthenticatedAccount(this.msalInstance, accounts, tenantId);
        this.client = this.getAuthenticatedClient();
        return this.deleteFile(fileId, driveId);
      }
      throw error;
    }
  }
}

export default SharePointService; 